// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item":"styles__view-slider-item__1Bzty","viewSliderItem":"styles__view-slider-item__1Bzty"};